import { Stack } from "@mui/material";
import { CoreButton, CoreTabs } from "@verity/components/core";
import { useState } from "react";
import i18n from "../../../../../../i18n";
import { getPlatformLabel } from "../../../utils";
import { ExportIcon } from "../../assets";
import { ProctoringOptionsType, SessionType } from "../../types";
import { CameraIcon } from "./assets";
import ActionCard from "./components/ActionCard";
import CodeEditorTab from "./tabs/CodeEditorTab";
import LiveEventsTab from "./tabs/LiveEventsTab";
import SessionInfoTab from "./tabs/SessionInfoTab";

type InProgressPageProps = {
	proctoringOptions: ProctoringOptionsType;
	sessionInfo: SessionType;
};

export default function InprogressPage({ proctoringOptions, sessionInfo }: InProgressPageProps) {
	const [tab, setTab] = useState("sessionInfo");

	const {
		proctoringOptionProfile: {
			proctoringOption: { enableWhiteboard, enableCodeEditor, codeEditorRoomId },
		},
	} = proctoringOptions;

	const Tabs = [
		{
			key: "sessionInfo",
			label: i18n.t("candidate.instructorInterviewPage.inProgress.tabs.info.name"),
		},
		{
			key: "liveEvents",
			label: i18n.t("candidate.instructorInterviewPage.inProgress.tabs.live.name"),
		},
	];

	// if (enableWhiteboard)
	// 	// || enableCodeEditor)
	// 	Tabs.push({
	// 		key: "codeEditor",
	// 		label: "Code Editor",
	// 	});

	const videoPlatformLabel = getPlatformLabel(proctoringOptions.candidateInterviewOptions.videoPlatform);

	return (
		<Stack spacing="15px" height="100%">
			<ActionCard
				title={i18n.t("candidate.instructorInterviewPage.inProgress.title")}
				description={i18n.t("candidate.instructorInterviewPage.inProgress.description", {
					videoPlatform: videoPlatformLabel,
				})}
				startIcon={<CameraIcon />}
				rightButton={
					<CoreButton
						endIcon={<ExportIcon />}
						onClick={() => window.open(proctoringOptions.candidateInterviewOptions.meetingLink, "_blank")}
					>
						{i18n.t("candidate.instructorInterviewPage.inProgress.launchCall", {
							videoPlatform: videoPlatformLabel,
						})}
					</CoreButton>
				}
			/>
			<CoreTabs
				width="max-content"
				scrollable
				secondary
				tabs={Tabs}
				onChange={(_, newTab) => setTab(newTab)}
				value={tab}
			/>

			{tab === "sessionInfo" && <SessionInfoTab proctoringOptions={proctoringOptions} sessionInfo={sessionInfo} />}
			<div hidden={tab !== "liveEvents"} style={{ height: "100%" }}>
				<LiveEventsTab sessionId={sessionInfo.id} />
			</div>
			{tab === "codeEditor" && (
				<CodeEditorTab
					showWhiteboard={enableWhiteboard}
					showCodeEditor={enableCodeEditor}
					codeEditorKey={codeEditorRoomId?.[0]}
				/>
			)}
		</Stack>
	);
}
